export default __webpack_public_path__ + "static/hardwax-7afe93dc702c73d6f9cf57d8eb95d9d1.png";